import { makeStyles } from '@material-ui/core';
import { stylesBase } from 'components/layout/Header/common/styles/base';

export const headerMenuMobileUseStyles = makeStyles(theme => ({
  ...stylesBase(theme),

  nav: {
    ...stylesBase(theme).nav,

    [theme.breakpoints.down('xs')]: {
      width: '100%',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    '& $linkActive': {
      color: theme.palette.common.white,
      '&::after': {
        backgroundColor: '#5B5DCF !important',
      },
    },
  },
  header: {
    ...stylesBase(theme).header,
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'nowrap',
      height: 'calc(100% - 132px)',

      // justifyContent: 'space-around',
      // padding: '23px 24px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: 0,
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      // overflowY: 'scroll',
      alignItems: 'flex-start',
      // '& > .MuiBox-root': {
      //   order: -1,
      // },
    },
  },
  headerBig: {
    paddingLeft: 20,
    paddingRight: 20,
  },
  link: {
    ...stylesBase(theme).link,

    [theme.breakpoints.down('xs')]: {
      display: 'flex',

      '&:active': {
        color: theme.palette.common.white,
      },
    },
  },
  main: {
    ...stylesBase(theme).main,

    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(3),
    },
    [theme.breakpoints.down('md')]: {
      '& $link': {
        ...theme.typography.h6,
      },
    },

    '& $nav': {
      '& li:not(:last-of-type)': {
        marginRight: 48,

        [theme.breakpoints.down('sm')]: {
          marginRight: 18,
          ...theme.typography.h5,
        },
      },

      '& li:last-of-type': {
        [theme.breakpoints.down('sm')]: {
          marginRight: 25,
        },
      },
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginLeft: 0,
      marginTop: 40,
      '& $link': {
        textDecoration: 'none',
        color: theme.palette.common.white,
        ...theme.typography.h5,
        fontWeight: 600,
        padding: '15px 16px',
      },
      '& $linkActive': {
        color: theme.palette.common.white,
        backgroundColor: '#5B5DCF', // @TODO Вынести цвет в expanded-theme
      },
    },
  },
  listItem: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  sub: {
    ...stylesBase(theme).sub,

    [theme.breakpoints.down('xs')]: {
      '& $link': {
        color: theme.palette.common.white,
        padding: '17px 0 17px 42px',
        ...theme.typography.subtitle2,
      },
      '& $linkActive': {
        color: theme.palette.common.white,
        backgroundColor: '#5B5DCF !important', // @TODO Вынести цвет в expanded-theme
        '&::after': {
          backgroundColor: '#5B5DCF !important',
        },
      },
    },
  },
  subCompliance: {
    '& $linkActive': {
      color: theme.palette.common.white,
      backgroundColor: 'transparent !important', // @TODO Вынести цвет в expanded-theme
      '&::after': {
        backgroundColor: '#5B5DCF !important',
      },
    },
    '& > li div': {
      '& $linkActive': {
        color: theme.palette.common.white,
        backgroundColor: '#5B5DCF !important', // @TODO Вынести цвет в expanded-theme
        '&::after': {
          backgroundColor: '#5B5DCF !important',
        },
      },
    },
  },
  openIcon: {
    marginLeft: 'auto',
  },
  openIconOpened: {
    transform: 'rotate(180deg)',
  },
  userBox: {
    ...stylesBase(theme).userBox,

    [theme.breakpoints.down('xs')]: {
      padding: '28px 16px 0 16px',
      width: '100%',
    },
  },
  logo: {
    [theme.breakpoints.down('md')]: {
      minWidth: 45,
      height: 42,
    },
  },
  downloadManual: {
    width: '100%',
    paddingBottom: 110,
    display: 'flex',
    alignItems: 'center',
    paddingTop: 18,
    color: theme.palette.common.white,
    ...theme.typography.body1,
    borderTop: `1px solid ${theme.palette.common.white}`,
    fontWeight: 600,
    lineHeight: '25px',

    '& svg': {
      marginRight: 10,
    },
  },
  downloadManualContainer: {
    marginTop: 29,
    paddingLeft: 16,
    paddingRight: 16,
  },
}));
